export const REFUND_TYPE = {
  full: 'full',
  partial: 'partial',
  cash: 'cash',
  norefund: 'norefund'
};
